export default {
    searchTerm: '',
    selectedSite: '',
    apiValoAuth: window.config.use_apivalo_auth,
    allMeasureFilesLoaded: false,
    allMeasureFilesUids: [],
    currentArea: null,
    currentEquipment: null,
    currentEnergyMeterNames: [],
    selectedItem: null,
    currentSimulation: null,
    siteDeclarationFields: [
        'company',
        'facility',
        'client',
        'address',
        'city',
        'zip_code',
        'energy_meter',
        'energy_meter_name'
    ],
    areaDeclarationFields: [
        'name',
        'description',
        'energy_meter',
        'energy_meter_name',
        'rules'
    ],
    equipmentDeclarationFields: [
        'name',
        'equipment_type',
        'description',
        'motor_type',
        'energy_meter',
        'energy_meter_name',
        'rules'
    ],
    energyMeters: [
        {
            key: 'current_measure',
            value: 'Mesure de courant sur une phase',
            icon: "/static/images/meter_icons/A1.png",
            prefix: 'A',
            usedIn: ['area', 'equipment'],
        },
        {
            key: 'wattmeter_without_reactive',
            value: 'Wattmètre sans calcul d’énergie réactive (3 phases)',
            icon: "/static/images/meter_icons/W1.png",
            prefix: 'W',
            usedIn: ['site', 'area', 'equipment'],
        },
        {
            key: 'wattmeter_with_reactive',
            value: 'Wattmètre avec calcul d’énergie réactive (3 phases)',
            icon: "/static/images/meter_icons/WVAR1.png",
            prefix: 'WVAR',
            usedIn: ['site', 'area', 'equipment'],
        },
        {
            key: 'enedis_meter',
            value: 'Compteur ENEDIS',
            icon: "/static/images/meter_icons/E1.png",
            prefix: 'E',
            usedIn: ['site'], // Not used in area or equipment context
        },
        {
            key: 'virtual_meter',
            value: 'Compteur virtuel',
            icon: "/static/images/meter_icons/V1.png",
            prefix: 'V',
            usedIn: ['area', 'equipment'], // Not used in site context
        }
    ],
    cosphiLibrary: [
        {
            "label": "Lampes à incandescence",
            "key": "incandescent_lamps",
            "value": 1
        },
        {
            "label": "Lampes fluorescentes (non compensées)",
            "key": "fluorescent_lamps_uncompensated",
            "value": 0.5
        },
        {
            "label": "Lampes fluorescentes (compensées)",
            "key": "fluorescent_lamps_compensated",
            "value": 0.93
        },
        {
            "label": "Lampes à décharge",
            "key": "discharge_lamps",
            "value": 0.5
        },
        {
            "label": "Fours à résistance",
            "key": "resistance_furnaces",
            "value": 1
        },
        {
            "label": "Fours à induction avec compensation intégrée",
            "key": "induction_furnaces_with_compensation",
            "value": 0.85
        },
        {
            "label": "Fours à chauffage diélectrique",
            "key": "dielectric_heating_furnaces",
            "value": 0.85
        },
        {
            "label": "Fours à arc",
            "key": "arc_furnaces",
            "value": 0.8
        },
        {
            "label": "Machines à souder à résistance",
            "key": "resistance_welding_machines",
            "value": 0.85
        },
        {
            "label": "Groupe rotatifs de soudage à l’arc",
            "key": "rotary_arc_welding_units",
            "value": 0.8
        },
        {
            "label": "Transformateurs-redresseurs de soudage à l’arc",
            "key": "arc_welding_transformer_rectifiers",
            "value": 0.75
        },
        {
            "label": "Charge résistive",
            "key": "resistive_load",
            "value": 1
        },
        {
            "label": "Pompe centrifuge",
            "key": "centrifugal_pump",
            "value": 0.8
        },
        {
            "label": "Pompe volumétrique",
            "key": "positive_displacement_pump",
            "value": 0.85
        },
        {
            "label": "Pompe à cavité progressive",
            "key": "progressive_cavity_pump",
            "value": 0.85
        },
        {
            "label": "Pompe multicellulaire",
            "key": "multistage_pump",
            "value": 0.84
        },
        {
            "label": "Ventilateur axial",
            "key": "axial_fan",
            "value": 0.8
        },
        {
            "label": "Ventilateur centrifuge",
            "key": "centrifugal_fan",
            "value": 0.85
        },
        {
            "label": "Ventilateur à vitesse variable",
            "key": "variable_speed_fan",
            "value": 0.9
        },
        {
            "label": "Compresseur à piston",
            "key": "piston_compressor",
            "value": 0.8
        },
        {
            "label": "Compresseur à vis",
            "key": "screw_compressor",
            "value": 0.85
        },
        {
            "label": "Compresseur centrifuge",
            "key": "centrifugal_compressor",
            "value": 0.9
        }
    ],
    equipmentProperties: [
        {
            name: "additional_power",
            default: 0,
        },
        {
            name: "cos_phi",
            default: 0.0,
        },
        {
            name: "cos_phi_known",
            default: false,
        },
        {
            name: "current",
            default: 0,
        },
        {
            name: "idle_power",
            default: 0,
        },
        {
            name: "power",
            default: 0,
        },
        {
            name: "rules",
            default: "",
        },
        {
            name: "second_phase_balancing_value",
            default: 0.0,
        },
        {
            name: "speed",
            default: 0,
        },
        {
            name: "tension",
            default: 0,
        },
        {
            name: "third_phase_balancing_value",
            default: 0.0
        }
    ]
};


// WEBPACK FOOTER //
// ./src/store/state.js